import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { QrObraAdminStatus } from '../../models/qr-obra-admin-status.model';
import { QrObraAdminStatusService } from '../../services/qr-obra-admin-status-service';

@Component({
  selector: 'app-obras-admin-status-edit',
  templateUrl: './obras-admin-status-edit.component.html',
  styleUrls: ['./obras-admin-status-edit.component.scss']
})
export class ObrasAdminStatusEditComponent extends BaseFormComponent<QrObraAdminStatus> implements OnInit {

  actionLabel: string = 'Novo';
  qrObraAdminStatus: QrObraAdminStatus;


  constructor(
    public activatedRoute: ActivatedRoute,
    private myService: QrObraAdminStatusService,
    private fb: FormBuilder,
    private navigation: NavigationService,
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = this.fb.group({
      name: ['', [Validators.required]]
    })
    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back([`qrobras/status`]);
  }

  getDataCreate(): QrObraAdminStatus {
    let data: QrObraAdminStatus;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar() {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: QrObraAdminStatus) => {
              this.msgSuccess('Status alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
              this.msgError(msg);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: QrObraAdminStatus) => {
              this.msgSuccess('Status cadastrado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
              this.msgError(msg);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {

    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['qrobras/status']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.error)
      }
    });
  }

}
